/**
 * @file Photo favorite button container for web galleries.
 */

import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import withFavoritePhotosMutations from '../hoc/withFavoritePhotosMutations';
import WebGalleryFavoritePhotoButton from '../components/WebGalleryFavoritePhotoButton/WebGalleryFavoritePhotoButton';
import { openModal } from '../../../actions/modal-actions';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    is_favorite: PropTypes.bool,
  }),
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
};

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const mapDispatchToProps = {
  openModal,
};

const WebGalleryFavoritePhotoButtonContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFavoritePhotosMutations,
)(WebGalleryFavoritePhotoButton);

WebGalleryFavoritePhotoButtonContainer.propTypes = propTypes;

export default WebGalleryFavoritePhotoButtonContainer;
